import Phaser from 'phaser';
import { CST } from "../CST";

var clickSound;
export default class Intro extends Phaser.Scene {
    constructor() {
        super(CST.SCENES.INTRO);
    }

    preload() {
        this.load.image('bg-intro', 'assets/bg-intro.png');
        this.load.image('btn_play', 'assets/english/start.png');
        this.load.image('back_btn', 'assets/english/go-backwards.png');
    }

    create(data) {
        clickSound = this.sound.add("clickSound");
        
        this.add.image(
            this.cameras.main.width / 2,
            this.cameras.main.height / 2,
            "bg-intro"
        );

        this.add.image(
            this.cameras.main.width / 2,
            this.cameras.main.height / 2 + 300,
            "btn_play"
        ).setInteractive({ useHandCursor: true }).on("pointerdown", () => {
            clickSound.play();
            this.scene.start(CST.SCENES.BOARD, { data: data.data });
        });

       this.add
        .image(
        this.cameras.main.width / 2 - 305,
        this.cameras.main.height / 2 + 300,
        "back_btn"
        )
        .setScale(1.2)
        .setInteractive({
            useHandCursor: true,
        })
        .on("pointerdown", () => {
            clickSound.play();
            this.scene.start(CST.SCENES.TIME, { scene: CST.SCENES.INTRO });
        });
    }

    update() {
        
    }
}